import { POST } from "./apiGenerators";

const generatorRequest = {
  exeGeneratorsFunction: (data) => POST(`/run_generators`, data),
}

export default generatorRequest;
